import * as yup from 'yup'
import useTrans from '../../../hooks/useTrans'

export default function getValidationSchema() {
  const t = useTrans()
  return yup.object().shape({
    azienda: yup.string().required(t('Questo campo è obbligatorio')).nullable(),
    nome: yup.string().required(t('Questo campo è obbligatorio')).nullable(),
    email: yup
      .string()
      .email(t("L'email deve essere valida"))
      .required(t('Questo campo è obbligatorio'))
      .nullable(),
    telefono: yup
      .string()
      .required(t('Questo campo è obbligatorio'))
      .min(8, t('Minimo {0} caratteri', [8]))
      .nullable(),
    catalogo: yup.string().required(t('Questo campo è obbligatorio')).nullable(),
    quantita: yup
      .number()
      .required(t('Questo campo è obbligatorio'))
      .moreThan(0, t('Solo numeri positivi'))
      .nullable(),
  })
}
